module.exports = __webpack_public_path__ + "static/media/country_ne.23b9fbd2.webp";